import API from "../../common/utils/API";
import {apiActionsTestcache} from "../../support/actions/SupportActionConstants";
import {activityLoggerActionTypes} from "../veritas-middleware/constants/UtilityMiddlewareConstants";
import {toUpperCaseSentence} from "../../common/utils/ToUpperCaseSentence";
import {displayErrorMessage} from "../../common/marvel-reducers/formMessageActions";
import {
    fetchTestcacheTableData, loadSourcesForTestcache,
    testcacheTableDataSuccess, toggleAddTestcacheRecordsModal,
    toggleDeleteTestcacheRecordsModal,
    toggleEditTestcacheRecordsModal, updateTestcacheFilters
} from "../../support/actions/TestcacheActions";
import * as Validation from "../../common/utils/Validation";

/**
 * This is the Middleware to handle the testcache operations from Marvel.
 * @param store, action
 * @returns Makes the List and CRUD API calls for testcache app in Marvel.
 */
const testcacheMiddleware = (store) => (next) => (action) => {

    switch (action.type) {

        case apiActionsTestcache.GET_ALL_TESTCACHE: {
            next(action);

            const { authToken } = action.payload;

            // Updated to use KYC endpoint
            API.getKYCTestcacheAll(authToken.idToken)
                .then(res => {
                    store.dispatch(testcacheTableDataSuccess(res.data.testcache_obj))
                    store.dispatch(updateTestcacheFilters());
                    store.dispatch(loadSourcesForTestcache(res.data.source_types_list))
                }).catch(error => {
                console.error(error)
            });

            break;
        }

        case apiActionsTestcache.ADD_TO_TESTCACHE: {
            next(action);

            const { authToken, testcacheObject } = action.payload;
            // validate inputs - KYC specific validation
            const validationResult = Validation.validateKYCTestcacheForm(testcacheObject);
            if (validationResult && validationResult.isValid) {
                // Updated to use KYC endpoint - no is_bv_record needed
                API.postKYCTestcacheRecord(authToken.idToken, testcacheObject)
                    .then(res => {
                        const log = {
                            object_id: res.data.guid,
                            object_type: "testcache_create",
                            user: authToken.account.name
                        };
                        store.dispatch({
                            type: activityLoggerActionTypes.LOG_CHANGE,
                            payload: {log, authToken}
                        });
                        store.dispatch(toggleAddTestcacheRecordsModal());
                        store.dispatch(fetchTestcacheTableData());
                    }).catch(error => {
                    const errorObject = error.response?.data || { error: 'An error occurred' };
                    const message = [];
                    // pretty print the error message for the user
                    for (let [key, value] of Object.entries(errorObject)) {
                        const errorMessage = key + ": " + toUpperCaseSentence(value)
                        message.push(errorMessage);
                    }
                    store.dispatch(displayErrorMessage(message, true));
                });
            }

            break;
        }

        case apiActionsTestcache.EDIT_TESTCACHE: {
            next(action);

            const { authToken, testcacheObject, testcacheGUID } = action.payload;
            // validate inputs - KYC specific validation
            const validationResult = Validation.validateKYCTestcacheForm(testcacheObject);
            if (validationResult && validationResult.isValid) {
                // Updated to use KYC endpoint - no is_bv_record needed
                API.putKYCTestcacheRecord(authToken.idToken, testcacheObject, testcacheGUID)
                    .then(res => {
                        const log = {
                            object_id: res.data.guid,
                            object_type: "testcache_edit",
                            user: authToken.account.name
                        };
                        store.dispatch({
                            type: activityLoggerActionTypes.LOG_CHANGE,
                            payload: { log, authToken }
                        });
                        store.dispatch(toggleEditTestcacheRecordsModal());
                        store.dispatch(fetchTestcacheTableData());
                    }).catch(error => {
                    const errorObject = error.response?.data || { error: 'An error occurred' };
                    const message = [];
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [key, value] of Object.entries(errorObject)) {
                        message.push(toUpperCaseSentence(Array.isArray(value) ? value[0] : value));
                    }
                    store.dispatch(displayErrorMessage(message, true));
                });
            }

            break;
        }

        case apiActionsTestcache.DELETE_TESTCACHE: {
            next(action);

            const { authToken, testcacheGUID } = action.payload;
            // Updated to use KYC endpoint
            API.deleteKYCTestcacheRecord(authToken.idToken, testcacheGUID)
                .then(res => {
                    const log = {
                        object_id: res.data.guid,
                        object_type: "testcache_delete",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: { log, authToken }
                    });
                    store.dispatch(toggleDeleteTestcacheRecordsModal());
                    store.dispatch(fetchTestcacheTableData());
                }).catch(error => {
                const errorObject = error.response?.data || { error: 'An error occurred' };
                const message = [];
                // pretty print the error message for the user
                // eslint-disable-next-line no-unused-vars
                for (let [key, value] of Object.entries(errorObject)) {
                    message.push(toUpperCaseSentence(Array.isArray(value) ? value[0] : value));
                }
                store.dispatch(displayErrorMessage(message, true));
            });

            break;
        }

        default: next(action)
    }
}


export default testcacheMiddleware;
